import { login, logout, getInfo } from "@/api/login";
import { getToken, setToken, removeToken } from "@/utils/auth";
const user = {
  state: {
    token: getToken(),
    name: "",
    avatar: "",
    roles: [],
    permissions: [],
    userInfo: null,
  },

  mutations: {
    SET_TOKEN: (state, token) => {
      state.token = token;
      setToken(token);
    },
    SET_NAME: (state, name) => {
      state.name = name;
    },
    SET_AVATAR: (state, avatar) => {
      state.avatar = avatar;
    },
    SET_ROLES: (state, roles) => {
      state.roles = roles;
    },
    SET_PERMISSIONS: (state, permissions) => {
      state.permissions = permissions;
    },
    SET_USERINFO: (state, userInfo) => {
      state.userInfo = userInfo;
      // localStorage.setItem("userInfo", JSON.stringify(userInfo))
    },
    SET_BUSINESSTIME: (state, obj) => {
      console.log(obj, "obj");
      state.businessTime = obj.timeArray;
      state.businessDate = obj.dateArray;
      state.reservationDuration = obj.reservationDuration;
      state.dateArrayTwo = obj.dateArrayTwo;
      state.dateArrayThree = obj.dateArrayThree;
      state.openingTime = obj.openingTime;
      state.closeingTime = obj.closeingTime;
      state.defaultItem = obj.defaultItem;
      state.basicSettings = obj.basicSettings;
    },
    SET_LOCKSETTING: (state, obj) => {
      state.doorLockSetting = obj;
    },
    SET_PHONECHECK: (state, obj) => {
      state.storePhoneCheck = obj;
    },
  },

  actions: {
    // 登录
    Login({ commit }, userInfo) {
      console.log("[ userInfo ]-68", userInfo);
      userInfo.username = userInfo.username.trim();
      const affiliationPc = "2";
      return new Promise((resolve, reject) => {
        login(userInfo)
          .then((res) => {
            console.log("[ resolve ] >");
            commit("SET_PHONECHECK", res.storePhoneCheck);
            commit("SET_TOKEN", res.token);

            resolve();
          })
          .catch((error) => {
            console.log("[ reject ] >");
            reject(error);
          });
      });
    },
    // 获取用户信息
    GetInfo({ commit, state, dispatch }) {
      return new Promise((resolve, reject) => {
        getInfo()
          .then((res) => {
            const user = res.user;
            const avatar = require("@/assets/logo/logo.png");
            if (res.roles && res.roles.length > 0) {
              // 验证返回的roles是否是一个非空数组
              commit("SET_ROLES", res.roles);
            } else {
              commit("SET_ROLES", ["ROLE_DEFAULT"]);
            }
            // commit("SET_PERMISSIONS", res.permissions)
            commit("SET_NAME", user.userName);
            commit("SET_AVATAR", avatar);
            commit("SET_USERINFO", {
              userId: user.userId,
              userType: user.userType,
              storeId: user.storeId,
              bossId: user.bossId,
              number: user.number,
              phonenumber: user.phonenumber,
              shopRegisterNumber: res.shopRegisterNumber,
              shopName: res.shopName,
            });
            // dispatch("getBasicSettings")

            resolve(res);
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 退出系统
    LogOut({ commit, state }) {
      return new Promise((resolve, reject) => {
        logout(state.token)
          .then(() => {
            commit("SET_TOKEN", "");
            commit("SET_ROLES", []);
            commit("SET_PERMISSIONS", []);
            removeToken();
            resolve();
          })
          .catch((error) => {
            reject(error);
          });
      });
    },

    // 前端 登出
    FedLogOut({ commit }) {
      return new Promise((resolve) => {
        commit("SET_TOKEN", "");
        removeToken();
        resolve();
      });
    },
  },
};

export default user;
